export default __webpack_public_path__ + "static/media/NextProject2.0de71196.png";